const headers = {
  name: "Inventory batch",
  pagination: {
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  },
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
    {
      type: "select",
      name: "sort",
      placeholder: "Sort",
      value: null,
      allowClear: true,
      options: [
        { value: "1", label: "Name (A-Z)" },
        { value: "2", label: "Name (Z-A)" },
        { value: "3", label: "Expiry (ASC)" },
        { value: "4", label: "Expiry (DES)" },
        { value: "5", label: "Purchase (Low)" },
        { value: "6", label: "Purchase (High)" },
        { value: "7", label: "Sale (Low)" },
        { value: "8", label: "Sale (High)" },
      ],
    },
    {
      type: "filter",
      name: "product",
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "Product",
      api: "get-all-products",
      value: null,
      options: null,
    },
    {
      type: "filter",
      name: "purchase",
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "Purchase",
      api: "get-all-purchase-orders",
      value: null,
      options: null,
    },
    {
      type: "filter",
      name: "received",
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "Received",
      api: "get-all-received-ids",
      value: null,
      options: null,
    },
    {
      type: "filter",
      name: "supplier",
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "Supplier",
      api: "get-all-suppliers",
      value: null,
      options: null,
    },
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
    {
      type: "add",
      path: "/app/inventory/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Batch",
        path: "",
      },
      {
        name: "Transfer",
        path: "/app/inventory/transfer",
      },
      {
        name: "Received",
        path: "/app/inventory/received",
      },
      {
        name: "Request",
        path: "/app/inventory/request",
      },
      {
        name: "Requested",
        path: "/app/inventory/requested",
      },
    ],
    total: [
      { value: "0", label: "Total" },
      { value: "0", label: "Active" },
      { value: "0", label: "Stocked" },
      { value: "0", label: "Outofstock" },
    ],
  },
};

export default headers;
